var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 7L15 11.375L14.1187 10.4937L17.6063 7L14.1187 3.50625L15 2.625L19.375 7ZM0.625 7L5 2.625L5.88125 3.50625L2.39375 7L5.88125 10.4937L5 11.375L0.625 7ZM7.7625 12.9275L11.025 0.75L12.2325 1.07313L8.97 13.25L7.7625 12.9275Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeEditorIcon);
export default __webpack_public_path__ + "static/media/code-editor-icon.4920b78e70627a092b925402a008d938.svg";
export { ForwardRef as ReactComponent };